module.exports = "/_next/static/images/mandy-nicole@3x-fa0a9555909e48dfc3e8df6f78a00114.png";